var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05037 0.557857C3.67907 0.109581 3.0908 -0.075251 2.54675 0.0278145C2.36219 0.0627773 2.1821 0.131023 2.0154 0.233032L1.14746 0.765161C0.439959 1.19844 -0.00301433 1.98142 1.54434e-05 2.79706C0.00870817 4.91437 1.27056 7.23967 3.73508 9.66199C6.1978 12.0826 8.55902 13.3217 10.7122 13.3333C11.5467 13.3378 12.3501 12.8994 12.7902 12.1978L13.3293 11.3393C13.7428 10.6808 13.601 9.83362 12.9961 9.34864L11.5813 8.21778C11.063 7.80347 10.3336 7.7622 9.76283 8.11502L8.27663 9.03208L8.17308 9.08837C7.89681 9.21576 7.61431 9.16741 7.38834 9.08376L7.26473 9.03246C7.25305 9.02711 7.24189 9.02187 7.23124 9.01677L6.98942 8.89338C6.5851 8.66647 6.14649 8.3094 5.63115 7.80349L5.63013 7.80249L5.47861 7.65206C4.95427 7.119 4.66317 6.72235 4.49373 6.42446C4.37472 6.21521 4.31347 6.02445 4.28402 5.90616L4.26247 5.79957L4.25289 5.70757C4.24427 5.51845 4.29473 5.32894 4.3987 5.16663L5.31254 3.73659C5.67253 3.17298 5.63034 2.4644 5.20697 1.95343L4.05037 0.557857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.2fad466c2a75f98b724cf18ece2b832c.svg";
export { ForwardRef as ReactComponent };